import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export const useGlobalPermission = () => {
  const { user, staticData } = useAuth();

  const hasPermission = (requiredPermission: string): boolean => {
    if (!user || !staticData || !staticData.rolePermissions) {
      // console.warn('Missing user or role permissions data');
      return false;
    }
    return staticData.rolePermissions.includes(requiredPermission);
  };

  return hasPermission;
};

export const usePermissionCheck = () => {
  const { user, staticData } = useAuth();

  const checkPermission = (requiredPermission: string): boolean => {
    if (!user || !staticData || !staticData.rolePermissions) {
      // console.warn('Missing user or role permissions data');
      return false;
    }
    return staticData.rolePermissions.includes(requiredPermission);
  };

  const requirePermission = (requiredPermission: string, action: () => void): void => {
    if (checkPermission(requiredPermission)) {
      action();
    } else {
      console.warn(`Permission denied: ${requiredPermission}`);
      toast.error(`Permission denied: ${requiredPermission}`);
    }
  };

  return { checkPermission, requirePermission };
};